import * as React from 'react';

import {
  ResetPasswordPayload,
  RESET_PASSWORD_FAILED,
  RESETTING_PASSWORD,
  ResetPasswordActionTypes,
  RESET_PASSWORD_COMPLETED,
  IResetPasswordFailedAction,
} from '@store/types';

import { ErrorStateType } from '@models/errors';

import { resetPassword as resetPasswordRequest } from '@services/user';

import { RequestError, HttpStatusCode } from '@utils';
import i18n from '@configs/i18n';
import routes from '@configs/routes.json';

import LocaleLinks from '../../../components/locale/LocaleLinks';

export const resetPassword = (content: ResetPasswordPayload): any => {
  return (dispatch: (action: ResetPasswordActionTypes) => void) => {
    dispatch({ type: RESETTING_PASSWORD });
    return resetPasswordRequest(content)
      .then(() => dispatch({ type: RESET_PASSWORD_COMPLETED }))
      .catch((error: RequestError) => {
        let message: JSX.Element = (
          <React.Fragment>{error.message}</React.Fragment>
        );
        if (error.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {
          switch (error.code) {
            case ErrorStateType.InvalidEmailAddress:
            case ErrorStateType.InvalidUsernamePassword:
              message = (
                <LocaleLinks
                  localeKey='resetPassword_error_invalidEmailAddress'
                  links={[{ name: 'create', route: routes.app.createAccount }]}
                />
              );
              break;
            default:
              message = i18n.t('common_unknownError');
              break;
          }
        }
        dispatch(resetPasswordFailed(message));
      });
  };
};

export const resetPasswordFailed = (
  error: JSX.Element
): IResetPasswordFailedAction => ({
  type: RESET_PASSWORD_FAILED,
  payload: error,
});
